export var StorageType;
(function (StorageType) {
    StorageType["SESSION"] = "SESSION";
    StorageType["LOCAL"] = "LOCAL";
    StorageType["COOKIE"] = "COOKIE";
    StorageType["CACHE"] = "CACHE";
})(StorageType || (StorageType = {}));
//# sourceMappingURL=storage-type.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/storage/storage-type.js
// module id = 59
// module chunks = 14